import React, { useState } from "react";
const EC = {binance:"#f59e0b",okx:"#a855f7",hyperliquid:"#06b6d4"};
export default function TopTradersPanel({ data }) {
  if (!data?.exchanges) return <p style={{color:"#6b7280"}}>데이터 없음</p>;
  const {exchanges,avg_skew,skew_direction,any_triggered,skew_threshold,signal} = data;
  const isLong = skew_direction==="long";
  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
        <div style={{padding:"7px 14px",borderRadius:9,
          background:any_triggered?(isLong?"rgba(34,197,94,.15)":"rgba(239,68,68,.15)"):"rgba(255,255,255,.04)",
          border:any_triggered?`1px solid ${isLong?"rgba(34,197,94,.4)":"rgba(239,68,68,.4)"}`:"1px solid #1e2433"}}>
          <p style={{fontSize:11,color:"#6b7280",marginBottom:2}}>평균 쏠림</p>
          <p style={{fontSize:18,fontWeight:700,color:any_triggered?(isLong?"#22c55e":"#ef4444"):"#6b7280"}}>
            {isLong?"▲ LONG":"▼ SHORT"} {Math.abs(avg_skew||0).toFixed(2)}%
          </p>
        </div>
        <div style={{fontSize:12,color:"#4b5563"}}>
          기준: ±{skew_threshold}% 쏠림 시 텔레그램 알림
          {any_triggered&&<span style={{color:"#f59e0b",marginLeft:6}}>← 발동 중!</span>}
        </div>
      </div>
      {signal?.notes?.map((n,i)=>(
        <div key={i} style={{padding:"7px 12px",borderRadius:8,
          background:"rgba(245,158,11,.08)",border:"1px solid rgba(245,158,11,.2)",
          fontSize:12,color:"#fde68a"}}>{n}</div>
      ))}
      {Object.entries(exchanges).map(([ex,d])=>{
        const acc=d.account||{}; const pos=d.position;
        const color=EC[ex]||"#888";
        return (
          <div key={ex}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:5}}>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <span style={{width:8,height:8,borderRadius:"50%",background:color,display:"inline-block"}}/>
                <span style={{fontWeight:600,fontSize:13}}>{ex.charAt(0).toUpperCase()+ex.slice(1)}</span>
                {acc.triggered&&<span style={{fontSize:11,fontWeight:700,color:"#f59e0b"}}>← 쏠림!</span>}
              </div>
              <div style={{display:"flex",gap:10,fontSize:12}}>
                <span style={{color:"#22c55e",fontWeight:700}}>롱 {acc.long_pct?.toFixed(1)}%</span>
                <span style={{color:"#ef4444",fontWeight:700}}>숏 {acc.short_pct?.toFixed(1)}%</span>
              </div>
            </div>
            <div style={{height:16,display:"flex",borderRadius:5,overflow:"hidden",background:"#1e2433",
              outline:acc.triggered?`1px solid ${color}55`:"none"}}>
              <div style={{width:`${acc.long_pct||50}%`,background:"#22c55e",transition:"width .4s"}}/>
              <div style={{flex:1,background:"#ef4444"}}/>
            </div>
          </div>
        );
      })}
      {data.updated_at&&<p style={{fontSize:11,color:"#374151"}}>{data.updated_at}</p>}
    </div>
  );
}
